import { Check, Cancel, PendingActions } from '@mui/icons-material';
import { orderStatus } from '../services/api/api';
import { Component } from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-multi-lang';

interface iProps {
  order_status: orderStatus;
  border?: string;
  color?: string;
  margin?:string;
  setChoice?:Function,
  disabled?:boolean

}
export const OrderStatus = ({ order_status, border, color ,margin,setChoice=()=>{},disabled}: iProps) => {
  const t=useTranslation()
  interface iObj {
    [key: string]: React.ReactElement;
  }
  let obj: iObj = {
    Pending: (
      <PendingActions
        sx={{
          borderRadius: '100%',
          fontSize:'1.2rem'
        }}
      />
    ),
    Approved: (
      <Check
        sx={{
          borderRadius: '100%',
          fontSize:'1.2rem'
        }}
      />
    ),

    Rejected: <Cancel  sx={{fontSize:'1.2rem'}}/>,
  };
  return (
    <Tooltip title={t(`${order_status}`)}>

        <div
       onClick={()=>!disabled? setChoice(order_status):()=>{}}
          style={{
            cursor:!disabled?'pointer':'not-allowed',
            borderRadius: '100%',
            border: 
            border

              ? border
              : `1px solid ${
                  order_status === 'Pending'
                    ? 'orange'
                    : order_status === 'Approved'
                    ? 'green'
                    : order_status === 'Rejected'
                    ? 'red'
                    : ''
                }`
              
                ,
                margin:margin,
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            color: 
            color

              ? color
              : ` ${
                  order_status === 'Pending'
                    ? 'orange'
                    : order_status === 'Approved'
                    ? 'green'
                    : order_status === 'Rejected'
                    ? 'red'
                    : ''
                }`
                ,
            fontSize: '0.7rem',
          }}>
          {obj[order_status]}
          {/* <span>{order_status}</span> */}
        </div>
    </Tooltip>
  );
};
